import { useRouter } from "next/router";
import { useState } from "react";
import Link from "next/link";
import classes from "./LanguageSwitcher.module.css";
import classNames from "classnames";
import { useClickOutside } from "@mantine/hooks";
import useTranslation from "next-translate/useTranslation";

import PolandFlag from "static/images/poland.png";
import EnglandFlag from "static/images/united-kingdom.png";
import CzechFlag from "static/images/czech-republic.png";
import GermanyFlag from "static/images/germany.png";
import FranceFlag from "static/images/france.png";
import RussiaFlag from "static/images/russia.png";
import SpainFlag from "static/images/spain.png";
import Image from "next/image";
import MenuIcon from "../../../static/icons/three_dot_menu.svg";

const LanguageSwitcher = () => {
  const [expanded, setExpanded] = useState(false);
  const router = useRouter();
  const ref = useClickOutside(() => setExpanded(false));
  const { t } = useTranslation("common");

  const setPersistLocaleCookie = (locale: string) => {
    setExpanded(false);
    const date = new Date();
    const expireMs = 100 * 24 * 60 * 60 * 1000; // 100 days
    date.setTime(date.getTime() + expireMs);
    document.cookie = `NEXT_LOCALE=${locale};expires=${date.toUTCString()};path=/`;
  };

  const flagImagesPath = "/flags/";

  const countryFlags = {
    pl: PolandFlag,
    en: EnglandFlag,
    cz: CzechFlag,
    de: GermanyFlag,
    fr: FranceFlag,
    ru: RussiaFlag,
    es: SpainFlag,
  };

  return (
    <div className={classes.languageSwticherContainer}>
      <div
        onClick={() => setExpanded(!expanded)}
        className={classes.currentLanguageContainer}
      >
        {/*eslint-disable-next-line @next/next/no-img-element */}
        <Image
          src={countryFlags[router.locale as keyof typeof countryFlags]}
          alt={`${router.locale}-flag`}
          width={28}
          height={28}
        />

        {/*<img*/}
        {/*  src={countryFlags[router.locale as keyof typeof countryFlags]}*/}
        {/*  alt={`${t("flag")} ${router.locale}`}*/}
        {/*  width={28}*/}
        {/*  className={classes.image}*/}
        {/*/>*/}
      </div>
      <div
        ref={ref}
        className={classNames(classes.languageList, {
          [classes.languageListExpanded]: expanded,
        })}
      >
        <ul>
          {router.locales
            ?.filter((locale) => locale !== router.locale)
            .map((locale) => (
              <li onClick={() => setPersistLocaleCookie(locale)} key={locale}>
                <Link locale={locale} href={router.asPath}>
                  {/*eslint-disable-next-line @next/next/no-img-element */}
                  <Image
                    src={countryFlags[locale as keyof typeof countryFlags]}
                    alt={`${locale}-flag`}
                    width={28}
                    height={28}
                  />
                  {/*<img*/}
                  {/*  src={countryFlags[locale as keyof typeof countryFlags]}*/}
                  {/*  alt={`${t("flag")} ${locale}`}*/}
                  {/*  width={28}*/}
                  {/*  className={classes.image}*/}
                  {/*/>*/}
                </Link>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};
export default LanguageSwitcher;
